import { motion } from "framer-motion";
import { useSiteSettings, type SiteSettings } from "@/hooks/useSiteSettings";

const defaultHeroFood = "/hero-main.jpg";

const HeroSection = () => {
  const { data } = useSiteSettings();
  const settings = data as SiteSettings | null;
  const heroFood = settings?.hero_image || defaultHeroFood;

  return (
    <section id="hero" className="min-h-[90vh] md:min-h-screen flex items-center pt-16 relative overflow-hidden" style={{ background: "var(--hero-gradient)" }}>
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-20 right-10 w-60 md:w-80 h-60 md:h-80 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-10 w-72 md:w-96 h-72 md:h-96 bg-accent/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 flex flex-col-reverse md:flex-row items-center gap-6 md:gap-8 py-8 md:py-12 relative z-10">
        <motion.div
          className="flex-1 text-center md:text-right"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <span className="inline-block bg-primary/10 text-primary font-cairo font-bold text-sm px-4 py-1.5 rounded-full mb-4 md:mb-6 border border-primary/20">
            🌿 منتجات غذائية طبيعية
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-cairo font-extrabold text-foreground leading-tight mb-4 md:mb-6">
            جنّة – <br />
            <span className="text-gradient">طعم الطبيعة في بيتك!</span>
          </h1>
          <p className="text-base md:text-xl text-muted-foreground font-cairo leading-relaxed mb-6 md:mb-8 max-w-xl mx-auto md:mx-0 md:mr-0">
            اكتشف أجود المنتجات الغذائية الأساسية بالجملة من دقيق، سكر، أرز، مكرونات، وتوابل. جودة عالية ونكهة لا تُنسى!
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center md:justify-start">
            <a
              href="#contact"
              className="inline-block font-cairo font-bold px-6 md:px-8 py-3 md:py-3.5 rounded-xl text-primary-foreground text-base md:text-lg transition-all duration-300 hover:shadow-lg hover:shadow-primary/25 hover:-translate-y-1"
              style={{ background: "var(--premium-gradient)" }}
            >
              تواصل معنا الآن
            </a>
            <a
              href="/products"
              className="inline-block bg-card font-cairo font-bold px-6 md:px-8 py-3 md:py-3.5 rounded-xl text-foreground text-base md:text-lg border border-border hover:border-primary/30 hover:-translate-y-1 transition-all duration-300"
            >
              تصفح المنتجات
            </a>
          </div>
        </motion.div>
        <motion.div
          className="flex-1 flex justify-center"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <img
            src={heroFood}
            alt="جنّة - منتجات غذائية طبيعية"
            width={800}
            height={1000}
            className="w-full max-w-[280px] sm:max-w-[340px] md:max-w-md drop-shadow-2xl rounded-2xl h-auto"
            fetchPriority="high"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
